import PropTypes from 'prop-types'
import FormContainer from '../FormContainer'
import Box from '@mui/material/Box'
import FullStepHeader from '../../FullStepHeader'
import { Button } from '@mui/material'
import ArrowRight from "@/assets/arrow_right.svg";

const AppsContainer = ({ title, subtitle, children, handleExitToEditor }) => {
  return (
    <Box
      className='md:overflow-hidden max-h-screen h-full bg-[#F3F4F8]'
    >
      <FullStepHeader />
      <Box
        className='w-fit md:w-full h-full relative flex items-center justify-center mx-2 md:m-0 min-h-[calc(100vh-48px)]'
      >
        <Box className="w-full md:w-[640px] mt-4 md:mt-8">
          <Box className="md:w-3/4 mx-auto mb-5">
            <FormContainer
              title={title}
              subtitle={subtitle}
              center
            />
          </Box>
          <Box>
            {children}
          </Box>
        </Box>
      </Box>
      {/* <Box className="hidden md:block fixed bottom-5 rounded right-10 z-40 flex align-middle !bg-gray-200 hover:!bg-gray-300 transition-colors ease-in !px-6">
        <Button
          className="!font-[Inter] !text-gray-600 font-[500]"
          endIcon={<img src={ArrowRight} />}
          onClick={handleExitToEditor}
        >
          Exit to Editor
        </Button>
      </Box> */}
    </Box>
  )
}

AppsContainer.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  handleExitToEditor: PropTypes.func.isRequired
}

export default AppsContainer
